import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22fonts.ts%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:%22../public/fonts/Outfit-variable.woff2%22,%22variable%22:%22--font-outfit-family%22,%22display%22:%22swap%22,%22weight%22:%22100%20900%22,%22fallback%22:[%22ui-sans-serif%22,%22system-ui%22,%22sans-serif%22]}],%22variableName%22:%22outfit%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'outfit', 'outfit Fallback', ui-sans-serif, system-ui, sans-serif",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
